<script>
export default {
  mounted() {
    this.darkMode();
  },
  methods: {
    darkMode() {
      const isDarkModeActive =
        JSON.parse(localStorage.getItem("isdark")) == null
          ? false
          : JSON.parse(localStorage.getItem("isdark"));
      this.isDarkModeActive = isDarkModeActive;
      console.log("localstorage dark toogle ", this.isDarkModeActive);
      // console.log("localstorage dark button ", isDarkModeActive);
      const body = document.querySelector("body");
      if (isDarkModeActive) {
        body.classList.add("dark");
      } else {
        body.classList.remove("dark");
        this.$forceUpdate();
      }
    },
    toggleTheme() {
      // const isDark = document.body.classList.toggle("dark");
      this.isDarkModeActive = !this.isDarkModeActive;
      console.log("localstorage dark toogle ", this.isDarkModeActive);
      const body = document.querySelector("body");
      localStorage.setItem("isdark", JSON.stringify(this.isDarkModeActive));
      if (this.isDarkModeActive) {
        body.classList.add("dark");
      } else {
        body.classList.remove("dark");
      }
      this.$forceUpdate();
    },
  },
  data() {
    return {
      isDarkModeActive: false,
    };
  },
};
</script>

<template>
  <div>
    <vs-button
      icon
      class="btn-theme-header mr-3"
      @click="toggleTheme"
      :warn="isDarkModeActive"
      :dark="!isDarkModeActive"
    >
      <i
        :class="`ti ${!isDarkModeActive ? 'ti-moon-filled' : 'ti-sun-filled'}`"
      ></i>
    </vs-button>
  </div>
</template>

<style scoped>
.vs-button.btn-theme-header {
  width: 2.5rem;
  height: 2.5rem;
  transition: 0.3s;
  background: none;
  box-shadow: none;
  & i {
    font-size: 1.5rem;
  }
}
</style>
